import { Formulas, SubscriptionEnvs } from "../../formula/models/formula.model";
import { SubscriptionIntervals } from "../models/eva-subscription.model";
import { EvaAddress } from "src/app/domains/address";

export class AdminEvaSubscriptionDto {
  subscription_id = "";
  formula: Formulas;
  subscription_status = "";
  env: SubscriptionEnvs = SubscriptionEnvs.MAIN_V3;
  interval: SubscriptionIntervals = SubscriptionIntervals.MONTHLY;
  trial_start_date: Date;
  trial_end_date: Date;
  active_start_date: Date;
  active_end_date: Date;
  onboarding_start_date: Date;
  onboarding_end_date: Date;
  mrr = 0;
  arr = 0;

  max_employees_accounts: number;
  max_accountants_accounts: number;

  eva_company_id = "";
  eva_company_name = "";
  eva_company_features = [];
  eva_company_canton = "";
  eva_company_vat_number = "";
  eva_company_ide = "";
  work_domains: string[] = [];
  eva_company_address_details: EvaAddress = new EvaAddress();
  hourly_email_limit: number;
  signature_date: Date;

  public static createInstance(jsonData: any): AdminEvaSubscriptionDto {
    const a = Object.assign(new AdminEvaSubscriptionDto(), jsonData);

    if (a.trial_start_date) a.trial_start_date = new Date(a.trial_start_date);
    if (a.trial_end_date) a.trial_end_date = new Date(a.trial_end_date);
    if (a.active_start_date) a.active_start_date = new Date(a.active_start_date);
    if (a.active_end_date) a.active_end_date = new Date(a.active_end_date);
    if (a.onboarding_start_date) a.onboarding_start_date = new Date(a.onboarding_start_date);
    if (a.onboarding_end_date) a.onboarding_end_date = new Date(a.onboarding_end_date);
    if (a.signature_date) a.signature_date = new Date(a.signature_date);

    // Convert address_details to EvaAddress instance
    if (jsonData.eva_company_address_details) {
      a.eva_company_address_details = EvaAddress.createInstance(jsonData.eva_company_address_details);
    }

    // Garantir que les champs itérables sont toujours des tableaux
    if (!Array.isArray(a.eva_company_features)) a.eva_company_features = [];
    if (!Array.isArray(a.work_domains)) a.work_domains = [];

    const rawInterval = jsonData.interval || jsonData.subscription_interval;
    if (rawInterval) {
      const interval = (rawInterval as string).toUpperCase();
      if (Object.values(SubscriptionIntervals).includes(interval as SubscriptionIntervals)) {
        a.interval = interval as SubscriptionIntervals;
      }
    }

    return a;
  }

  public static createInstances(jsonData: any[]): AdminEvaSubscriptionDto[] {
    return jsonData.map(AdminEvaSubscriptionDto.createInstance);
  }

  get isReallyActive(): boolean {
    if (this.subscription_status !== "ACTIVE") return false;
    if (!this.mrr || this.mrr <= 0) return false;
    if (this.active_end_date && this.active_end_date < new Date()) return false;
    return true;
  }

  get tag_severity(): string {
    if (this.subscription_status === "ACTIVE") return "success";
    if (this.subscription_status === "TRIAL") return "warning";
    if (this.subscription_status === "INACTIVE") return "danger";
    return "secondary";
  }

  get tag_label(): string {
    if (this.subscription_status === "PENDING") return "En attente de validation";
    if (this.subscription_status === "ACTIVE") return "Actif";
    if (this.subscription_status === "TRIAL") return "En Test";
    if (this.subscription_status === "INACTIVE") return "Inactif";
    return "Inconnu";
  }

  get excelExport(): any {
    return {
      Nom: this.eva_company_name,
      TVA: this.eva_company_vat_number,
      IDE: this.eva_company_ide,
      Canton: this.eva_company_canton,
      Formule: this.formula,
      Env: this.env,
      Features: this.eva_company_features.join(", "),
      "Nb collaborateurs": this.max_employees_accounts,
      "Nb fiduciaires": this.max_accountants_accounts,
      "Limite mail/heure": this.hourly_email_limit,
      "Date signature": this.signature_date ? new Date(this.signature_date).toLocaleDateString() : "",
      "Début test": this.trial_start_date ? new Date(this.trial_start_date).toLocaleDateString() : "",
      "Fin test": this.trial_end_date ? new Date(this.trial_end_date).toLocaleDateString() : "",
      "Début Actif": this.active_start_date ? new Date(this.active_start_date).toLocaleDateString() : "",
      "Fin Actif": this.active_end_date ? new Date(this.active_end_date).toLocaleDateString() : "",
      "Début onboarding": this.onboarding_start_date ? new Date(this.onboarding_start_date).toLocaleDateString() : "",
      "Fin onboarding": this.onboarding_end_date ? new Date(this.onboarding_end_date).toLocaleDateString() : "",
      MRR: this.mrr,
      ARR: this.arr,
      Statut: this.tag_label,
    };
  }
}
